var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 47.161,
    viewBox: "0 0 161 47.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-180.766 -609.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M216.433,669.983H205.6v-3.392a11.088,11.088,0,0,1-3.124,2.831,12.636,12.636,0,0,1-6.282,1.547,14.886,14.886,0,0,1-10.13-3.915,17.1,17.1,0,0,1-.565-24.183q.338-.355.7-.689a14.72,14.72,0,0,1,9.9-3.719,14.162,14.162,0,0,1,6.117,1.35,12.159,12.159,0,0,1,3.388,2.6v-3h10.835ZM205.927,654.7a6.643,6.643,0,0,0-2.033-4.9,6.719,6.719,0,0,0-4.919-2.017,6.624,6.624,0,0,0-5.277,2.426,6.866,6.866,0,0,0,0,8.981,6.558,6.558,0,0,0,5.277,2.426,6.737,6.737,0,0,0,4.932-2,6.654,6.654,0,0,0,2.021-4.917Z",
    transform: "translate(0 -14.922)",
    fill: "#006ea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M270.176,670.967H259.341V640.4h10.835Z",
    transform: "translate(-39.961 -15.91)",
    fill: "#006ea5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(233.068 609.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M321.576,654.041a28.965,28.965,0,0,1-10.6,2.272,23.565,23.565,0,1,1,.1-47.128,29.3,29.3,0,0,1,10.5,2.272v14a13.258,13.258,0,0,0-3.362-3.049,12.808,12.808,0,0,0-6.729-1.891,12.153,12.153,0,0,0-7.915,2.741,12.716,12.716,0,0,0,0,18.989,12.143,12.143,0,0,0,7.915,2.739,12.812,12.812,0,0,0,6.729-1.889,13.089,13.089,0,0,0,3.362-3.052Z",
    transform: "translate(-287.195 -609.184)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M399.31,654.519a15.545,15.545,0,0,1-4.183,10.9,21.017,21.017,0,0,1-28.422,0,15.878,15.878,0,0,1-4.183-11.165,15.213,15.213,0,0,1,4.216-10.571q5.1-5.564,14.524-5.566a17.977,17.977,0,0,1,13.833,5.566A15.387,15.387,0,0,1,399.31,654.519Zm-11.264,0a7.083,7.083,0,0,0-7.052-7.114h-.061a6.756,6.756,0,0,0-5.442,2.514,7.1,7.1,0,0,0,0,9.229,6.753,6.753,0,0,0,5.442,2.515,7.053,7.053,0,0,0,7.112-6.994c0-.051,0-.1,0-.152Z",
    transform: "translate(-325.501 -623.889)",
    fill: "#141212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M474.954,670.288H464.12V654.83a10.424,10.424,0,0,0-.917-5.357,4.569,4.569,0,0,0-4.025-1.942,5.6,5.6,0,0,0-4.131,1.67,6.449,6.449,0,0,0-1.505,4.722v16.369H442.706V639.73h10.835v3.852a13.845,13.845,0,0,1,3.453-3.062,12.887,12.887,0,0,1,6.412-1.45,11.843,11.843,0,0,1,8.023,2.668,11.345,11.345,0,0,1,3.52,9.09Z",
    transform: "translate(-366.283 -624.377)",
    fill: "#141212"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M270.166,615.141a6,6,0,0,1-5.923,6.078h-.153a5.81,5.81,0,0,1-4.287-1.771,6.073,6.073,0,0,1,8.588-8.59A5.8,5.8,0,0,1,270.166,615.141Z",
    transform: "translate(-39.312)",
    fill: "#141212"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAicon);
export default __webpack_public_path__ + "static/media/aicon.e0cf77e1aa75a151e360b80900bb9d7c.svg";
export { ForwardRef as ReactComponent };